import { lazy, Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import CircularProgress from '@mui/joy/CircularProgress'
import Box from '@mui/joy/Box'

const PortalAccountsPage = lazy(() => import('./pages/PortalAccountsPage'))
const BrokerCatalogPage = lazy(() => import('./pages/BrokerCatalogPage'))

export default function BrokersRoutes() {
    return (
        <Suspense
            fallback={
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 200 }}>
                    <CircularProgress />
                </Box>
            }
        >
            <Routes>
                <Route path="portal-accounts" element={<PortalAccountsPage />} />
                <Route path="catalog" element={<BrokerCatalogPage />} />
                <Route path="*" element={<Navigate to="portal-accounts" replace />} />
            </Routes>
        </Suspense>
    )
}
